import type { ReactNode } from 'react'
import Navbar from './Navbar'
import Footer from './sections/Footer'
import FloatingCTA from './FloatingCTA'

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div>
      <div
        className="fixed inset-0 -z-10 pointer-events-none"
        style={{
          backgroundImage: "url('/images/tlo2.webp')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />
      <div className="fixed inset-0 -z-[9] pointer-events-none bg-black/60" />
      <Navbar />
      <main>{children}</main>
      <Footer />
      <FloatingCTA />
    </div>
  )
}
